import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { INotification } from '../interfaces/INotification';
import { INotificationCount } from 'modules/sales/settings/order-status/interfaces/INotification';

interface NotificationSearchParams {
  filters?: Record<string, any>;
  search?: string;
  page?: number;
  size?: number;
  sort?: Record<string, any>;
  projections?: Record<string, any>;
  populate?: boolean;
}

class NotificationService extends EntityApiService<INotification> {
  searchNotification = (params?: NotificationSearchParams, config?: any): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/user/search'), params, config));
  };

  getUserNotifications = (params?: NotificationSearchParams, config?: any): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/user/search'), params, config));
  };

  getNotificationCount = (config?: any): Promise<INotificationCount> => {
    return this.handleResponse(ApiClientService.get(this.getPath('/user/count'), config));
  };

  removeNotification = (notificationId: string, config?: any): Promise<any> => {
    if (!notificationId) {
      return Promise.reject(new Error('notificationId is required'));
    }
    return this.handleResponse(
      ApiClientService.post(this.getPath(`/${notificationId}/user/got-it`), undefined, config),
    );
  };

  removeAllNotifications = (params?: any, config?: any): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/user/got-it/all'), params, config));
  };

  markAsRead = (notificationId: string, config?: any): Promise<any> => {
    if (!notificationId) {
      return Promise.reject(new Error('notificationId is required'));
    }
    return this.handleResponse(ApiClientService.post(this.getPath(`/${notificationId}/user/view`), undefined, config));
  };

  viewNotification = (notificationId: string, params?: any, config?: any): Promise<any> => {
    if (!notificationId) {
      return Promise.reject(new Error('notificationId is required'));
    }
    return this.handleResponse(ApiClientService.post(this.getPath(`/${notificationId}/user/view`), params, config));
  };

  markAsReadRange = (fromId: string, toId: string, config?: any): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/user/view'), { from: fromId, to: toId }, config));
  };

  markAllAsRead = (config?: any): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath('/user/view'), null, config));
  };
}

export default new NotificationService('/ms-auth/api/notifications');
